<template>
    <div class="video" v-loading="loading">
        <p class="video-title">Video</p>
        <div class="video-content"
             v-infinite-scroll="load"
             :infinite-scroll-disabled="isLock"
             :infinite-scroll-distance="40"
             v-if="value&&value.length">
            <div class="line" v-for="item in value" :key="item.id" @click="clickLine(item)">
                <div class="video-image">
                    <el-image class="video-image" :src="changeThumb(item.sourceAsMap.thumb,130,76)" fit="cover">
                    </el-image>
                    <i class="video-paly-btn"></i>
                </div>
                <div>
                    <p :title="item.sourceAsMap.title" class="overflow-hidden-2">{{item.sourceAsMap.title}}</p>
                    <p>{{timeTampToTime(item.sourceAsMap.published)}}</p>
                </div>
            </div>
        </div>
        <div v-else class="video-content no-data">no data</div>
    </div>
</template>

<script>
import MixinsDate from '@/views/TheHome/mixins/dateTime'

export default {
  name: 'videoList',
  mixins: [MixinsDate],
  props: {
    value: Array
  },
  data () {
    return {
      isLock: false,
      loading: false
    }
  },
  watch: {
    value: {
      handler () {
        this.isLock = false
      },
      deep: true
    }
  },
  methods: {
    changeThumb (url, w, h) {
      let ext = url.split('.')
      let ret
      if ((url.indexOf('https://img.imsilkroad.com/a/thumb/') == -1 && url.indexOf('https://img.imsilkroad.com/a/') >= 0)) {
        ret = url.replace('com/a/', 'com/a/thumb/') + '!w' + w + '_h' + h + '.' + ext.pop()
        return ret
      } else if (url.indexOf('https://img.imsilkroad.com/a/thumb/') >= 0) {
        ret = url.replace(/w[0-9]*_/, 'w' + w + '_').replace(/_h[0-9]*/, '_h' + h)
        return ret
      }
      return url
    },
    load () {
      this.isLock = true
      this.$emit('update')
    },
    clickLine (item) {
      const id = item.id.split('_')[1] || ''
      id && (window.location.href = 'https://en.imsilkroad.com' + '/db/#/video/1/article/' +
        id)
      // item.sourceAsMap.url && (window.location.href = item.sourceAsMap.url)
    }
  }
}
</script>

<style scoped lang="scss">
    .video {
        padding: 10px 10px 10px 16px;

        .video-title {
            font-size: 16px;
            color: #212529;
            font-weight: bolder;
            margin: 0 0 6px 0;
        }

        .video-content {
            height: calc(100% - 36px);
            overflow-y: scroll;

            .line {
                display: flex;
                align-items: center;
                width: 100%;
                padding: 16px 0;
                // margin: 0 0 10px 0;
                border-bottom: 1px solid #ECECEC;
                cursor: pointer;

                &:hover {
                    > div:nth-of-type(2) {
                        p {
                            color: #208EFF;
                        }
                    }
                }

                .video-image {
                    position: relative;
                    width: 130px;
                    height: 76px;
                    margin: 0 10px 0 0;
                    flex-shrink: 0;

                    .video-paly-btn {
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        margin: auto;
                        width: 19px;
                        height: 24px;
                        background-image: url(../../../../assets/images/play.png);
                        background-size: cover;
                    }
                }

                > div {
                    p {
                        &:nth-of-type(1) {
                            font-size: 15px;
                            font-weight: bolder;
                            line-height: 15px;
                            word-break: break-all;
                        }

                        &:nth-of-type(2) {
                            margin: 5px 0 0 0;
                            font-size: 12px;
                            color: #8c939d;
                        }
                    }
                }
            }
        }

        .no-data {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            color: #999999;
        }
    }

    .overflow-hidden-2 {
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        display: -webkit-box !important;
        -webkit-line-clamp: 2 !important;
        -webkit-box-orient: vertical !important;
    }
</style>
